import React from 'react'
import Typography from 'components/atoms/Typography'
import { Container, Row, Col } from 'components/qstrap'

const Greeting = () => (
  <div id="kit-greeting" className="kit-greeting">
    <Container>
      <Row>
        <Col md="7">
          <Typography component="h2" variant="title" className="kit-greeting__title">Hello, Quipperian</Typography>
          <Typography component="p" variant="body" className="kit-greeting__body">
            kamu mempunyai mimpi kuliah di luar negeri gratis? Sudah berkali-kali ikut tes beasiswa namun berujung pada kekecewaan? Jangan cepat menyerah ya, karena seperti pepatah bilang, banyak jalan menuju Roma.
          </Typography>
        </Col>
      </Row>
    </Container>
  </div>
)

export default Greeting
